const subscriptionPlanManagementPage = {
  en: {
    subscriptionPlanManagementPage: {
      updated: "Plan updated successfully!",
      updateFailed: "Failed to update plan",
      confirmReset: "Reset all plans to default values? This will update prices for Basic ($200) and Professional ($500) plans.",
      resetDone: "Plans reset to defaults successfully!",
      resetFailed: "Failed to reset plans",
      title: "Subscription Plan Management",
      subtitle: "Manage pricing and features for all subscription plans",
      resetDefaults: "Reset to Defaults",
      loadingPlans: "Loading plans...",
      active: "Active",
      inactive: "Inactive",
      features: "Features:",
      featuresLabel: "Features",
      priceUsd: "Price (USD)",
      apiCallsPerDay: "API Calls/Day",
      unlimited: "Unlimited",
      editPlan: "Edit Plan",
      editTitle: "Edit Subscription Plan: {{name}}",
      editDesc: "Update pricing, features, and settings for this plan",
      planName: "Plan Name",
      planNamePlaceholder: "e.g., Professional",
      displayOrder: "Display Order",
      pricePlaceholder: "e.g., 29.00",
      priceDisplay: "Price Display",
      priceDisplayPlaceholder: "e.g., $29/month",
      apiCallsLabel: "API Calls Per Day",
      apiCallsPlaceholder: "e.g., 500 (use -1 for unlimited)",
      unlimitedHint: "Use -1 for unlimited API calls",
      featuresLabel: "Features",
      addFeaturePlaceholder: "Add new feature...",
      planIsActive: "Plan is Active",
      cancel: "Cancel",
      saveChanges: "Save Changes"
    }
  },
  fr: {
    subscriptionPlanManagementPage: {
      updated: "Plan mis à jour avec succès !",
      updateFailed: "Échec de la mise à jour du plan",
      confirmReset: "Réinitialiser tous les plans aux valeurs par défaut ? Cela mettra à jour les prix des plans Basique (200 $) et Professionnel (500 $).",
      resetDone: "Plans réinitialisés aux valeurs par défaut avec succès !",
      resetFailed: "Échec de la réinitialisation des plans",
      title: "Gestion des plans d'abonnement",
      subtitle: "Gérez les tarifs et les fonctionnalités de tous les plans d'abonnement",
      resetDefaults: "Rétablir les valeurs par défaut",
      loadingPlans: "Chargement des plans...",
      active: "Actif",
      inactive: "Inactif",
      features: "Fonctionnalités :",
      featuresLabel: "Fonctionnalités",
      priceUsd: "Prix (USD)",
      apiCallsPerDay: "Appels API/jour",
      unlimited: "Illimité",
      editPlan: "Modifier le plan",
      editTitle: "Modifier le plan d'abonnement : {{name}}",
      editDesc: "Mettez à jour les tarifs, les fonctionnalités et les paramètres de ce plan",
      planName: "Nom du plan",
      planNamePlaceholder: "ex. : Professionnel",
      displayOrder: "Ordre d'affichage",
      pricePlaceholder: "ex. : 29.00",
      priceDisplay: "Affichage du prix",
      priceDisplayPlaceholder: "ex. : 29 $/mois",
      apiCallsLabel: "Appels API par jour",
      apiCallsPlaceholder: "ex. : 500 (utilisez -1 pour illimité)",
      unlimitedHint: "Utilisez -1 pour des appels API illimités",
      featuresLabel: "Fonctionnalités",
      addFeaturePlaceholder: "Ajouter une fonctionnalité...",
      planIsActive: "Le plan est actif",
      cancel: "Annuler",
      saveChanges: "Enregistrer les modifications"
    }
  }
};

export default subscriptionPlanManagementPage;
